import { app, Component } from 'apprun';
import { agency } from './api';
import { __ } from './Txlat';
import { getId, getAgencyLink, add_meta, add_link, set_title, setDetailLanguageLink } from './utility';
import PropertyListing from './propertyListing';
import AgentListing from './agentListing';
import AgencyNav from './agencyNav';
import Charts from './charts';
import AgencyDetailProfile from './template/agency-detail-profile-template';
import InquiryForm from './inquiry-form';

class AgencyDetail extends Component {

  view = (state) => {
    return (<AgencyDetailProfile agency={state.agency} />);
  };

  update = {
    '#': async (state) => {

      state.id = getId();
      state.agency = await agency.getAgencyByID(state.id);

      const agency_url = getAgencyLink(state.agency);
      if (window.location.pathname !== encodeURI(agency_url)) {
        window.location.href = agency_url;
        return;
      }
      state.properties = await agency.getAllAgencyProperties(state.agency.alaia_id);

      state.agencyAgents = await agency.getAllAgencyAgents(state.agency.id);

      setDetailLanguageLink(state.agency, getAgencyLink);
      const { name, address, city, province, postal_code } = state.agency;
      const description = `${name} ${address} ${city} ${province} ${postal_code}`;
      add_meta(description);
      set_title(`${description} | ${__('Royal LePage Commercial')}`);
      add_link('canonical', agency_url);
      add_link('alternate', agency_url, 'en');
      add_link('alternate', getAgencyLink(agency, 'fr'), 'fr');

      app.run('/setComponentState', state);
      return state;
    },
  };
}

new AgencyDetail().start('.agent-profile-wrap');
new PropertyListing().start('#tab-properties');
new AgencyNav().start('.agent-nav-wrap');
new Charts().start('#agent-stats-chart');
new AgentListing().start('#tab-agents');
new InquiryForm({ isPopup: true }).start('.mobile-property-form .modal-body');
